import styled from 'styled-components'

const MastheadContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.nswBrandDark};
  color: #fff;
  padding: 0.5rem 0;
`
MastheadContainer.displayName = 'MastheadContainer'

const MastheadText = styled.div`
  padding: 0rem 1rem;
  font-size: 0.75rem;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
  max-width: var(--nsw-container-width);
`
MastheadText.displayName = 'MastheadText'

export default function Masthead() {
  return (
    <MastheadContainer>
      <MastheadText>A NSW Government website</MastheadText>
    </MastheadContainer>
  )
}
